import { render, staticRenderFns } from "./TransactionTableRow.vue?vue&type=template&id=edc34c12&"
import script from "./TransactionTableRow.vue?vue&type=script&lang=js&"
export * from "./TransactionTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports